export default function LoginLink() {
  return (
    <a
      href="https://penzu.com/app/login"
      className="font-medium text-white hover:text-red-50 px-3 lg:px-4 py-2 flex items-center transition duration-150 ease-in-out whitespace-nowrap"
    >
      Sign in
    </a>
  );
}
